import { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const SearchContext = createContext(null);

export function SearchProvider({ children }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const navigate = useNavigate();

  const clearSearch = useCallback(() => {
    setSearchQuery('');
    setIsSearchOpen(false);
  }, []);

  const handleResultClick = useCallback((result) => {
    clearSearch();
    // Navigate based on result type
    switch (result.type) {
      case 'customer':
        navigate('/customers');
        break;
      case 'enquiry':
        navigate(`/enquiries/${result.id}`);
        break;
      case 'quotation':
        navigate(`/quotations/${result.id}`);
        break;
      case 'serviceRequestForm':
        navigate(`/service-request-forms/${result.id}`);
        break;
      case 'proformaInvoice':
        navigate(`/proforma-invoices/${result.id}`);
        break;
      default:
        break;
    }
  }, [clearSearch, navigate]);

  const value = {
    searchQuery,
    setSearchQuery,
    isSearchOpen,
    setIsSearchOpen,
    clearSearch,
    handleResultClick,
  };

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
}

export default SearchContext;
